module.exports = __webpack_public_path__ + "static/media/dark3.679804ac.JPG";